<template>
  <div id="search-form-location-distance">
    <div class="search-form-location-distance__location">
      <label class="mb-0" for="distance">Location</label>
      <LocationSearch :is-search-page="true" :defer-search="true" :disabled="disabled" @input="$emit('input', $event)" @location-selected="$emit('location-selected', $event)" @clear-inputs="$emit('clear-inputs')" @use-current-location="$emit('use-current-location')" />
    </div>
  </div>
</template>

<script>
import LocationSearch from '@/components/header/search/LocationSearch'

export default {
  name: 'SearchFormLocationDistance',

  components: {
    LocationSearch,
  },

  props: {
    distance: {
      type: Number,
      required: true,
    },
    distanceOptions: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    distanceModel: {
      get() {
        return this.distance
      },
      set(value) {
        this.$emit('update:distance', value)
      },
    },
  },
}
</script>

<style scoped lang="scss">
#search-form-location-distance {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background-color: $color-search-section-bg;

  .search-form-location-distance__location {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  label,
  ::v-deep .form-group label,
  ::v-deep .form-group legend {
    font-family: "Gill Sans", "Inter", sans-serif;
    font-weight: 600;
    font-size: 18px;
    color: $color-text-dark;
  }

  .search-form-location-distance__distance {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  ::v-deep .btn-group {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1 1 0;
      min-height: 40px;
      padding: 8px 12px;
      border-radius: 4px;
      border: 1px solid $color-grey-dark-20;
      background-color: #fff;
      font-family: "Gill Sans", "Inter", sans-serif;
      font-size: 18px;
      line-height: 1;
      color: $color-text-dark;

      &:hover:not(.active) {
        border-color: $color-grey-dark-20;
        background-color: rgba($color-yellow-main, 0.15);
      }

      &.active {
        background-color: rgba($color-yellow-main, 0.5);
        border-color: $color-grey-dark;
        font-weight: 600;
      }
    }
  }
}
</style>
